import styled from 'styled-components'
import { Box } from 'vvs-uikit'

export const ButtonMenuWrap = styled(Box)`
  overflow-x: scroll;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`
